"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpViewInlineAssessment: {
        of: '{{question}} of {{total}}',
        branch: 'Branch Question',
        core: 'Core Question',
        itemTag: '{{itemTag}}, {{question}}.',
    },
};
